// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2Lf63","borderedWhite":"Button_borderedWhite__28Thh","filledBlack":"Button_filledBlack__3_vUP"};